module.exports = {
    "source_code": "HLXEMS",
    "site_id": "cader-ssw.bu.edu",
    "title": "Boston University - Center for Aging & Disability Education & Research",
    "tfn": "",
    "url": "https://cader-ssw.bu.edu/",
    "gtm_code": "GTM-KPFSBC8F",
}